export default __webpack_public_path__ + "static/media/edu1.a8f6099a.jpg";